import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataStorageService } from '../../../data-storage.service';
import { AvailableComponents } from '../../../side-bar/enumAvailableComponents';
import { PPhostedPricing } from '../../../../models/PPhostedPricing.model';
import { ApiService } from '../../../api.service';
import { PricingService } from '../../../pricing.service';
import { SecurityService } from '../../../security.service';
import { ApiTextService } from '../../../apiServices/text/text.service';
import { preserveWhitespacesDefault } from '@angular/compiler';

@Component({
  selector: 'app-peoplephone-hosted',
  templateUrl: './peoplephone-hosted.component.html',
  styleUrls: ['./peoplephone-hosted.component.scss']
})
export class PeoplephoneHostedComponent implements OnInit, OnDestroy {

  pricingListUsers: PPhostedPricing[];
  pricingListNodes: PPhostedPricing[];
  pricingListSoftphone: PPhostedPricing[];
  pricingListConnectorStandard: PPhostedPricing[];
  pricingListConnectorApi: PPhostedPricing[];
  usersAvailable: number;
  canHaveFreeSoftphone: boolean;
  promoSoftphone: boolean;



  constructor(
    public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    private tApi: ApiTextService,
    private api: ApiService,
    private pricing: PricingService) {

    this.pricingListUsers = [];
    this.pricingListNodes = [];
    this.pricingListSoftphone = [];
    this.pricingListConnectorStandard = [];
    this.pricingListConnectorApi = [];
    this.usersAvailable = 0;
    this.canHaveFreeSoftphone = this.dataStorageService.currentState.wishedSolution.PeoplephoneHosted 
    && ( this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetCyberlink 
        || this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetIPworldcom)
    this.promoSoftphone = this.canHaveFreeSoftphone && this.dataStorageService.currentState.PPhosted.softphoneMonthlyCost == 0
    pricing.getPPHostedUsersPricelist().then(data => {
      this.pricingListUsers = data;
      this.updateTotalUsersCosts(this.totalSelectedUsers());
    });
    pricing.getPPHostedNodesPricelist().then(data => {
      this.pricingListNodes = data;
    });
    pricing.getPPHostedSoftphonePricelist().then(data => {
      this.pricingListSoftphone = data;
    });
    pricing.getPPHostedConnectorStanPricelist().then(data => {
      this.pricingListConnectorStandard = data;
    });
    pricing.getPPHostedConnectorApiPricelist().then(data => {
      this.pricingListConnectorApi = data;
    });
  }

  ngOnInit() {
    const element = document.getElementById('pfHosted');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['PeoplephoneHosted'];
    this.api.getPPHosted(this.dataStorageService.currentState.offerID);
  }

  ngOnDestroy() {
    const element = document.getElementById('pfHosted');
    element.classList.remove('active');
  }

  putValue() {
    this.api.putPPHosted(this.dataStorageService.currentState.offerID);
  }

  totalAvailablveUsers(): number {
    return 0;
  }

  updateUsersIpTerminalCount(event) {
    this.updateUsersCount(event,
      this.dataStorageService.currentState.PPhosted.usersIpTerminal,
      value => this.dataStorageService.currentState.PPhosted.usersIpTerminal = value);
  }

  updateUsersFax2EmailCount(event) {
    this.updateUsersCount(event,
      this.dataStorageService.currentState.PPhosted.usersFax2Email,
      value => this.dataStorageService.currentState.PPhosted.usersFax2Email = value);
  }

  updateusersAnalogFaxCount(event) {
    this.updateUsersCount(event,
      this.dataStorageService.currentState.PPhosted.usersAnalogFax,
      value => this.dataStorageService.currentState.PPhosted.usersAnalogFax = value);
  }

  updateUsersCentralizedVoiceMail(event) {
    this.updateUsersCount(
      event,
      this.dataStorageService.currentState.PPhosted.usersCentralizedVoiceMail,
      value => this.dataStorageService.currentState.PPhosted.usersCentralizedVoiceMail = value);
  }

  updateUsersReserveCount(event) {
    this.updateUsersCount(
      event,
      this.dataStorageService.currentState.PPhosted.usersReserve,
      value => this.dataStorageService.currentState.PPhosted.usersReserve = value);
  }

  updateIvrNodes(event) {
    const maxNodes = this.getPeoplefoneHostedMaxNodes();
    this.validateCount(event);
    if (event.target.value > maxNodes) {
      event.target.value = maxNodes;
    }
    this.dataStorageService.currentState.PPhosted.nodes = event.target.value;
    this.dataStorageService.currentState.PPhosted.nodesMonthlyCost = this.nodesCost();
    this.totalCost();
    this.putValue();
  }

  updateSoftphone(event) {
    this.validateCount(event);
    this.dataStorageService.currentState.PPhosted.softphones = event.target.value;
    this.dataStorageService.currentState.PPhosted.softphoneMonthlyCost = this.softphoneCost();
    this.totalCost();
    this.putValue();
  }

  updateConnectorStandard(event) {
    this.validateCount(event);
    this.dataStorageService.currentState.PPhosted.connectorStandard = event.target.value;
    this.dataStorageService.currentState.PPhosted.connectorStandardMonthlyCost = this.connectorStandMonthlyCost();
    this.dataStorageService.currentState.PPhosted.connectorStandardUniqueCost = this.connectorUniqueCost();
    this.totalCost();
    this.putValue();
  }


  updateConnectorApi(event) {
    this.validateCount(event);
    this.dataStorageService.currentState.PPhosted.connectorApi = event.target.value;
    this.dataStorageService.currentState.PPhosted.connectorApiMonthlyCost = this.connectorApiMounthlyCost();
    this.totalCost();
    this.putValue();
  }


  updateUsersCount(event, currentUsersCount, usersCountSetter: Function): number {
    this.validateCount(event);
    this.updateUsersCountWithMaxAllowedValueIfOverLimit(event, currentUsersCount);
    usersCountSetter.call(this.dataStorageService.currentState.PPhosted, event.target.value);
    this.updateTotalUsersCosts(this.totalUsers());
    this.totalUsers();
    this.putValue();
    return event.target.value;
  }



  private updateUsersCountWithMaxAllowedValueIfOverLimit(event: any, specificUsersCount: number) {
    this.usersAvailable = this.getAvailableUsers(specificUsersCount);
    if (event.target.value > this.usersAvailable) {
      event.target.value = this.usersAvailable;
    }
  }

  private validateCount(event) {
    if (event.target.value === '' || event.target.value < 0) {
      event.target.value = 0;
    }
  }

  getAvailableUsers(currentUserTypeCount: number) {
    return this.getPeoplefoneHostedMaxUsers() - (this.totalSelectedUsers() - currentUserTypeCount);
  }


  totalSelectedUsers(): number {
    const ppHosted = this.dataStorageService.currentState.PPhosted;
    const sum = Number(ppHosted.usersIpTerminal)
      + Number(ppHosted.usersFax2Email)
      + Number(ppHosted.usersAnalogFax)
      + Number(ppHosted.usersCentralizedVoiceMail)
      + Number(ppHosted.usersReserve);
    return sum;
  }

  totalUsers(): number {
    const matchinPricing = this.getMatchingUsersPricing(this.totalSelectedUsers());
    if (matchinPricing === undefined) {
      alert('No matching range for selected users count - check your configuration');
      return;
    }
    this.dataStorageService.currentState.PPhosted.usersAvailable = matchinPricing.countTo;
    return matchinPricing.countTo;
  }

  updateTotalUsersCosts(usersCount: number) {
    const pricingElement = this.getMatchingUsersPricing(usersCount);
    if (pricingElement === undefined) {
      alert('Too many users selected');
      return;
    }
    this.dataStorageService.currentState.PPhosted.usersMonthlyCost = pricingElement.costMonthly;
  }

  getMatchingUsersPricing(usersCount: number): PPhostedPricing {
    if (usersCount <= 0 || this.pricingListUsers.length == 0) {
      return this.emptyUsersPricing();
    }
    if (usersCount > this.getPeoplefoneHostedMaxUsers()) {
      return undefined;
    }

    let pricingElement = this.pricingListUsers.filter(e => e.countFrom <= usersCount && e.countTo >= usersCount).pop();
    if (pricingElement === undefined) {
      pricingElement = this.pricingListUsers.reduce((prev, current) => prev.countFrom > current.countFrom ? current : prev);
    }
    return pricingElement;
  }

  emptyUsersPricing() {
    return new PPhostedPricing();
  }
  nodesCost(): number {
    let cost = 0;
    this.pricingListNodes.forEach(elem => {
      if (this.dataStorageService.currentState.PPhosted.nodes >= elem.countFrom &&
        this.dataStorageService.currentState.PPhosted.nodes <= elem.countTo) {
        cost = elem.costMonthly;
      }
    });
    return cost;
  }

  softphoneCost(): number {
    let cost = 0;
    if(this.promoSoftphone) return cost;

    this.pricingListSoftphone.forEach(elem => {
        cost = elem.costMonthly * this.dataStorageService.currentState.PPhosted.softphones;
    });

    return cost;
  }

  setSofphonePrice(event) {
    this.promoSoftphone = event.target.checked
    this.updateSoftphone({target:{
      value: this.dataStorageService.currentState.PPhosted.softphones
    }})
  }

  connectorStandMonthlyCost(): number {
    let cost = 0;
    this.pricingListConnectorStandard.forEach(elem => {
      cost = elem.costMonthly * this.dataStorageService.currentState.PPhosted.connectorStandard;
    });
    return cost;
  }

  connectorUniqueCost(): number {
    let cost = 0;
    if (this.dataStorageService.currentState.PPhosted.connectorStandard > 0) {
      this.pricingListConnectorStandard.forEach(elem => {
        cost = elem.uniqueCost;
      });
    }
    return cost;
  }

  connectorApiMounthlyCost(): number {
    let cost = 0;
    this.pricingListConnectorApi.forEach(elem => {
      cost = elem.costMonthly * this.dataStorageService.currentState.PPhosted.connectorApi;
    });
    return cost;
  }

  totalCost(): number {
    this.dataStorageService.currentState.PPhosted.totalCost = this.nodesCost()
      + this.dataStorageService.currentState.PPhosted.usersMonthlyCost + this.softphoneCost() + this.connectorStandMonthlyCost() + this.connectorApiMounthlyCost();
    return this.dataStorageService.currentState.PPhosted.totalCost;
  }

  cancelClick() {
    this.dataStorageService.currentState.PPhosted.usersMonthlyCost = 0;
    this.dataStorageService.currentState.PPhosted.usersIpTerminal = 0;
    this.dataStorageService.currentState.PPhosted.usersFax2Email = 0;
    this.dataStorageService.currentState.PPhosted.usersAnalogFax = 0;
    this.dataStorageService.currentState.PPhosted.usersCentralizedVoiceMail = 0;
    this.dataStorageService.currentState.PPhosted.usersReserve = 0;
    this.dataStorageService.currentState.PPhosted.nodes = 0;
    this.dataStorageService.currentState.PPhosted.softphones = 0;
    this.dataStorageService.currentState.PPhosted.connectorStandard = 0;
    this.dataStorageService.currentState.PPhosted.connectorApi = 0;
  }

  updateText(event, key: string) {
    const value = event.target.value;
    this.tApi.putUIText(key, value);
    this.dataStorageService.setUIText(key, value);
  }

  getDesc() {
    return this.dataStorageService.filterUIText('offer.options.pf-hosted.desc');
  }

  private getPeoplefoneHostedMaxUsers(): number {
    return this.getPricingRangeMax(this.pricingListUsers);
  }

  private getPeoplefoneHostedMaxNodes(): number {
    return this.getPricingRangeMax(this.pricingListNodes);
  }

  private getPricingRangeMax(pricingList: PPhostedPricing[]): number {
    if (pricingList.length == 0) {
      return 0;
    }
    return pricingList.reduce((prev, current) => prev.countTo > current.countTo ? prev : current).countTo;

  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/peoplephone-hosted/peoplephone-hosted.component.ts